module.exports = __webpack_public_path__ + "static/img/yuanL.f702e256.svg";